/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Options01({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Options01_svg__a)"><path fillRule="evenodd" d="M1.5 3.6h1.977a2.351 2.351 0 1 0 0-1.2H1.5a.6.6 0 0 0 0 1.2m4.25.55a1.15 1.15 0 1 1 0-2.3 1.15 1.15 0 0 1 0 2.3" clipRule="evenodd" /><path d="M9.4 3a.6.6 0 0 1 .6-.6h4.5a.6.6 0 1 1 0 1.2H10a.6.6 0 0 1-.6-.6M9.4 13a.6.6 0 0 1 .6-.6h4.5a.6.6 0 1 1 0 1.2H10a.6.6 0 0 1-.6-.6M6.5 8.6a.6.6 0 1 0 0-1.2h-5a.6.6 0 0 0 0 1.2z" /><path fillRule="evenodd" d="M1.5 12.4a.6.6 0 1 0 0 1.2h1.977a2.351 2.351 0 1 0 0-1.2zm3.1.6a1.15 1.15 0 1 0 2.3 0 1.15 1.15 0 0 0-2.3 0M15.1 8a.6.6 0 0 1-.6.6h-1.4v1.15a.6.6 0 0 1-.6.6H9a.6.6 0 0 1-.6-.6v-3.5a.6.6 0 0 1 .6-.6h3.5a.6.6 0 0 1 .6.6V7.4h1.4a.6.6 0 0 1 .6.6m-3.2-1.15H9.6v2.3h2.3z" clipRule="evenodd" /></g><defs><clipPath id="Options01_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;